// Shared icon types

export interface IconProps {
  className?: string
  size?: number | string
  width?: number | string
  height?: number | string
  color?: string
  strokeWidth?: number
  fill?: string
  onClick?: () => void
  'aria-label'?: string
  role?: string
  style?: React.CSSProperties
}

// Helper to get size classes or explicit dimensions
export const getIconSize = (props: IconProps): { width: number | string; height: number | string } => {
  if (props.width !== undefined || props.height !== undefined) {
    return {
      width: props.width ?? props.height ?? 24,
      height: props.height ?? props.width ?? 24
    }
  }
  return {
    width: props.size ?? 24,
    height: props.size ?? 24
  }
}
